<template>
  <v-tooltip
    :bottom="direction === 'bottom'"
    :disabled="!truncated"
    :left="direction === 'left'"
    :max-width="maxWidth"
    :right="direction === 'right'"
    :top="direction === 'top'"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-truncated="(t) => (truncated = t)"
        :style="{
          '--desktop-line-clamp': effectiveDesktopLineClamp,
          '--mobile-line-clamp': effectiveMobileLineClamp,
        }"
        class="text-clamp"
        v-bind="attrs"
        v-on="on"
      >
        <slot></slot>
      </span>
    </template>
    <span class="tooltip-content">{{ value }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      default: "bottom",
      required: false,
      validator: (value) => {
        return ["bottom", "right", "left", "top"].includes(value);
      },
    },
    maxWidth: {
      type: Number,
      default: 300,
      required: false,
    },
    // Unified override applied to both breakpoints. When set, it wins over
    // desktopLineClamp and mobileLineClamp. Leave unset to use per-breakpoint defaults.
    lineClamp: {
      type: Number,
    },
    // Line clamp applied at the sm breakpoint and up (>= 600px). Default: 2.
    desktopLineClamp: {
      type: Number,
      default: 2,
    },
    // Line clamp applied at the xs breakpoint (<= 599.98px). Default: 0 (no clamp).
    mobileLineClamp: {
      type: Number,
      default: 0,
    },
  },

  data: function () {
    return {
      truncated: false,
    };
  },

  computed: {
    effectiveDesktopLineClamp: function () {
      return this.lineClamp != null ? this.lineClamp : this.desktopLineClamp;
    },
    effectiveMobileLineClamp: function () {
      return this.lineClamp != null ? this.lineClamp : this.mobileLineClamp;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--desktop-line-clamp);
  line-clamp: var(--desktop-line-clamp);
  overflow: hidden;
  overflow-wrap: anywhere;

  @media only screen and (max-width: 599.98px) {
    -webkit-line-clamp: var(--mobile-line-clamp);
    line-clamp: var(--mobile-line-clamp);
  }
}

:deep(.tooltip-content) {
  overflow-wrap: anywhere;
}
</style>
